<template>
  <div class="alinc" ref="verifyBox" @touchmove.prevent>
    <!-- #ifdef APP-PLUS -->
    <XlSliderVerify ref="verify" :loading="loading" :customLang="customLang" size="small" @statusChange="statusChange"></XlSliderVerify>
    <!-- #endif -->
  </div>
</template>
 
<script setup>
import { defineProps, defineEmits, ref, onMounted, watch } from 'vue';
// #ifdef APP-PLUS
import { XlSliderVerify } from "@shining3d/ui-components";
// #endif

function getCheckData (list) {
  let str = '';
  if(Array.isArray(list) && list.length ){
    list.forEach((v) => {
      str += v.join('|') + '|'
    });
    str = str.slice(0, -1);
  }
  return str;
}

const props = defineProps({
  reload: {
    type: Boolean,
    default: false
  },
  scene: {
    type: String,
    default: 'register'
  },
  customLang: String
});
const verify = ref(null)
const verifyBox = ref(null)
const emit = defineEmits([ 'resetInit', 'captchaCheckBack']);

const loading = ref(false)
const reloadFn = () => {
  verify.value && verify.value.reload();
}

function getSliderParams() {
  let arr = [];
  if (verifyBox.value) {
    const verifyBoxDom = verifyBox.value.getBoundingClientRect();
    // 组件左上角坐标
    const smLeftTXY = [Math.round(verifyBoxDom.x), Math.round(verifyBoxDom.y)];
    // 组件右下角坐标
    const smRightBXY = [Math.round(verifyBoxDom.x + verifyBoxDom.width), Math.round(verifyBoxDom.y + verifyBoxDom.height)];

    const sliderBtn = verifyBox.value.querySelector('.xl-slider-verify--slider');
    // 滑块宽高
    const sliderBtnXY = [sliderBtn.clientWidth, sliderBtn.clientHeight];

    // 添加数据
    arr = [smLeftTXY, smRightBXY, sliderBtnXY];
  }
  return arr;
}

const statusChange = () => {
  loading.value = true;
  const data = getCheckData(getSliderParams());
  emit('captchaCheckBack', {
    data,
    callback: (res) => {
      loading.value = false;
      if(!res){
        verify.value && verify.value.putFail();
        // 2s后重新获取，重置
        setTimeout(() => {
          emit('resetInit', () => {
            reloadFn();
          }, true );
        }, 2000);
      }
    }
  })
}
watch(() => props.reload, (newV, oldV) => {
  if (newV) {
    reloadFn();
  }
});

</script>
